import * as React from "react";
import { Link } from "@reach/router";
import axios from "axios";

class CookieTest extends React.Component {
  constructor(props){
    super(props);
    this.state = {}
  }
  componentDidMount() {
    axios.get('/w/get_cookie').then(
      response => {
        var respData = response.data;
        this.setState(state => ({ data: respData }));
      }
    )
  }
  render() {
    return this.state.data ? <>
      <p>Msisdn: {this.state.data.msisdn}</p>
      <p>artist: {this.state.data.artist}</p>
      <p>exired: {this.state.data.expired}</p>
      <p>exired date: { new Date(this.state.data.expired).toLocaleDateString()}</p>
      <p>operator: {this.state.data.operator}</p>

    </> :
      <h2>Loading</h2>
  }

}

export default CookieTest;